import { Button } from "@/components/ui/button";
export default function HeroSection() {
  return <section data-section-id="264316" id="hero-section" className="bg-cover bg-center bg-[linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_bespoke_hero.png)] py-24 md:py-32 px-6 flex items-center justify-center text-center relative overflow-hidden">
      <div className="container max-w-4xl mx-auto flex flex-col items-center relative z-10">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold mb-6 tracking-tighter text-white">
          Let's Design Your Masterpiece.
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl leading-relaxed font-sans">
          Tell us about the world you want to see, and we will flawlessly arrange every detail. Your extraordinary escape begins here.
        </p>
        <div className="hidden">
          <Button size="lg" className="bg-[#1a365d] text-white hover:bg-[#1a365d]/90 font-default font-semibold text-base px-8 py-6 rounded-lg shadow-md transition-all hover:shadow-lg">
            Enviar Mensaje
          </Button>
        </div>
      </div>
    </section>;
}